import React, { Component } from 'react';
import { Row } from 'antd';
import i18n from 'react-intl-universal';
import styles from './ForbiddenPage.scss';

import Button from '../../components/Button/Button';
import iPad from '../../assets/images/ipad.png';

export default class ForbiddenPage extends Component {
  download = () => {
    window.open('http://www.jianshu.com/apps/download');
  };

  toHome = () => {
    window.location.href = window.location.origin;
  };

  render() {
    return (
      <Row className={styles['wrap']}>
        <div className={styles['content']}>
          <img className={styles['img']} src={iPad} alt=""/>
          <span className={styles['desc']}>
            {i18n.get('global.forbidden-desc')}
          </span>
          <Button
            className={styles['btn']}
            type={'primary'}
            strong
            onClick={this.download}
          >
            {i18n.get('global.download')}
          </Button>
          <Button
            className={styles['btn']}
            type={'primary'}
            onClick={this.toHome}
          >
            {i18n.get('global.to-home')}
          </Button>
        </div>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ForbiddenPage/ForbiddenPage.js